<template src="./template/index.html"></template>
<script>
import Datepicker from "vuejs-datepicker";
import DibbleJS from "../../../dibble";

export default {
    name: "RentalReportModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        status: String,
        dateInput: {
            type: Date,
            default: new Date(),
            required: false
        },
        currentReason: {
            type: String,
            required: false,
            default: ''
        }
    },
    components: { Datepicker },
    data() {
        return {
            dibbleJs: DibbleJS,
            date: new Date(),
            reason: ''
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        updateDateNoRentalModal () {
            if (!this.reason) {
                DibbleJS.toastErrorMessage('Please type the reason')
                return
            }
            this.$emit("sendDateRentalModal", {date: this.customFormatter(this.date), reason: this.reason})
        }
    },
    watch: {
        visible (val) {
            if (val) {
                this.date = this.dateInput
                this.reason = this.currentReason
            }
        }
    }
}
</script>

<style lang="scss">
.modal {
    background: transparent;
    transition: opacity 0.15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .modal-form {
        display: flex;
        height: auto;
        align-items: center;
        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 8px;
            width: 100%;
            .title {
                font-size: 14px;
                margin: 0;
                margin-right: 10px;
            }
        }
    }
    button {
        float: right;
    }
}
.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}
</style>
